var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "info-item",
        {
          attrs: {
            isEnabled: _vm.isEnabled,
            label: _vm.resource("DmVisualizer_ChangeInfo_Website")
          },
          on: {
            "set-enabled": function($event) {
              return _vm.$emit("set-enabled", $event)
            }
          }
        },
        [
          _c("info-text-input", {
            attrs: {
              placeholder: _vm.resource(
                "DmVisualizer_ChangeInfo_Placeholder_Website"
              ),
              isEnabled: _vm.isEnabled
            },
            on: {
              input: function($event) {
                return _vm.$emit("input", $event)
              }
            },
            model: {
              value: _vm.website,
              callback: function($$v) {
                _vm.website = $$v
              },
              expression: "website"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }